import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 预获取组合订单数据
export function getOrderInfo (studentId) {
  return request({
    url: `${parent}/api/order/combination/info/pre?studentId=${studentId}`,
    method: 'get'
  })
}

// 组合订单金额试算
export function trialOrderPrice (data) {
  return request({
    url: `${parent}/api/order/combination/info/trial`,
    method: 'post',
    data
  })
}

// 创建组合订单
export function createCombinationOrder (data) {
  return request({
    url: `${parent}/api/order/combination/create`,
    method: 'post',
    data
  })
}
